import React, { useContext, useState } from "react";
import * as FaIcons from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import LeloCharterLinks from "./LeloLinks";

import AuthContext from "../../context/auth/authContext";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

import Logo from "./Logo";

import llacLogo from "../../img/llac-circle.png";

const AdminSidebar = () => {
  const authContext = useContext(AuthContext);
  const { logout, user } = authContext;

  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { sidebarStatus, handleToggleMenu, sidebarOpen } = adminRegistrationContext;

  // Handle undefined case - default to true (sidebar open)
  const isSidebarOpen = sidebarOpen !== undefined ? sidebarOpen : true;

  const location = useLocation();

  const getActiveSection = (route = null) => {
    const path = location.pathname.toLowerCase();
    if (route) return path.includes(route.toLowerCase());

    if (path.includes('/interest-forms') || path.includes('/registration-forms') ||
        path.includes('/lelo-forms') || path.includes('/scheduled-orientations')) return 'forms';

    if (path.includes('/add-interest') || path.includes('/add-registration') ||
        path.includes('/addlelo') || path.includes('/editlelo')) return 'actions';

    if (path.includes('/permissions') || path.includes('/intersession')) return 'setup';

    return null;
  };


  // const prodUrl = `https://enrollments.llac.org`;
  // const stagingUrl = `https://enrollment-app-staging.azurewebsites.net`;
  const siteUrl =
    // import.meta.env.MODE === "production"
    import.meta.env.VITE_NODE_ENV === "production" ||
    import.meta.env.VITE_NODE_ENV === "staging"
      ? `${import.meta.env.VITE_SITE_URL}/admin-login`
      : "http://localhost:3000/admin-login";

  return (
    <div className={`admin-sidebar ${isSidebarOpen ? '' : 'closed-sidebar'}`}>
      <div className="wrapper">
        <div className="top-logo">
          <Link to="/dashboard">
            <Logo size={1} />
          </Link>
        </div>
        <div className="links">
          {/* <h2 className="text-center menu-title">Menu Links</h2> */}
          <ul>
            <li>
              <div
                className="flex-container"
                onClick={() => handleToggleMenu("forms")}
                style={{
                  color: getActiveSection() === 'forms' ? '#6e8f49' : '',
                }}
              >
                <div className="left">
                  <FaIcons.FaClipboard className="menu-icon" />
                  <span>View Entries</span>
                </div>

                <FaIcons.FaCaretRight
                  className="caret-icon"
                  style={{
                    transform: sidebarStatus.forms
                      ? "rotate(90deg)"
                      : "rotate(0deg)",
                  }}
                />
              </div>
              <ul style={{ display: sidebarStatus.forms ? "block" : "none" }}>
                <li>
                  <Link to="/interest-forms" style={{
                    color: getActiveSection('/interest-forms') ? '#6e8f49' : ''
                  }}>
                    <span>Interests</span>
                  </Link>
                </li>
                <li>
                  <Link to="/registration-forms" style={{
                    color: getActiveSection('/registration-forms') ? '#6e8f49' : ''
                  }}>
                    <span>Primary Enrollments</span>
                  </Link>
                </li>
                <li>
                  <Link to="/lelo-forms" style={{
                    color: getActiveSection('/lelo-forms') ? '#6e8f49' : ''
                  }}>
                    <span>Secondary Enrollments</span>
                  </Link>
                </li>
                <li>
                  <Link to="/scheduled-orientations" style={{
                    color: getActiveSection('/scheduled-orientations') ? '#6e8f49' : ''
                  }}>
                    <span>Scheduled Orientations</span>
                  </Link>
                </li>
              </ul>
            </li>
            {user &&
              (user.userStatus === "Contributor" ||
                user.userStatus === "Admin" ||
                user.userStatus === "Super Admin") && (
                <li>
                  <div
                    className="flex-container"
                    onClick={() => handleToggleMenu("actions")}
                    style={{
                      color: getActiveSection() === 'actions' ? '#6e8f49' : '',
                    }}
                  >
                    <div className="left">
                      <FaIcons.FaEdit className="menu-icon" />
                      <span>New Entry</span>
                    </div>
                    <FaIcons.FaCaretRight
                      className="caret-icon"
                      style={{
                        transform: sidebarStatus.actions
                          ? "rotate(90deg)"
                          : "rotate(0deg)",
                      }}
                    />
                  </div>
                  <ul
                    style={{
                      display: sidebarStatus.actions ? "block" : "none",
                    }}
                  >
                    <li>
                      <Link to="/add-interest" style={{
                        color: getActiveSection('/add-interest') ? '#6e8f49' : ''
                      }}>
                        <span>Add Interest</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/add-registration" style={{
                        color: getActiveSection('/add-registration') ? '#6e8f49' : ''
                      }}>
                        <span>Add Primary Registration</span>
                      </Link>
                    </li>
                    <LeloCharterLinks />
                  </ul>
                </li>
              )}
            {user &&
              (user.userStatus === "Contributor" ||
                user.userStatus === "Admin" ||
                user.userStatus === "Super Admin") && (
                <li>
                  <div
                    className="flex-container"
                    onClick={() => handleToggleMenu("setup")}
                    style={{
                      color: getActiveSection() === 'setup' ? '#6e8f49' : '',
                    }}
                  >
                    <div className="left">
                      <FaIcons.FaCog className="menu-icon" />
                      <span>Setup</span>
                    </div>
                    <FaIcons.FaCaretRight
                      className="caret-icon"
                      style={{
                        transform: sidebarStatus.setup
                          ? "rotate(90deg)"
                          : "rotate(0deg)",
                      }}
                    />
                  </div>
                  <ul
                    style={{
                      display: sidebarStatus.setup ? "block" : "none",
                    }}
                  >
                    {user &&
                    (user.userStatus === "Admin" ||
                      user.userStatus === "Super Admin") && (
                      <li>
                        <Link to="/permissions" style={{
                          color: getActiveSection('/permissions') ? '#6e8f49' : ''
                        }}>
                            {/* <FaIcons.FaUserShield className="menu-icon" /> */}
                            <span>App Permissions</span>
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link to="/intersession" style={{
                        color: getActiveSection('/intersession') ? '#6e8f49' : ''
                      }}>
                        <span>Secondary Enrollments</span>
                      </Link>
                    </li>
                    {user &&
                    (user.userStatus === "Admin" ||
                      user.userStatus === "Super Admin") && (
                     <li>
                  <Link to="/email-logs" style={{
                    color: getActiveSection('/email-logs') ? '#6e8f49' : ''
                  }}>
                    <span>Email Logs</span>
                  </Link>
                    
                </li>
                )}
                  </ul>
                </li>
              )}
            {/* <LeloCharterLinks /> */}
          </ul>
          
          {/* Bottom content within scrollable area */}
          <div className="bottom-content">
            <a
              href={`https://login.microsoftonline.com/learn4life.org/oauth2/v2.0/logout?post_logout_redirect_uri=${siteUrl}`}
              onClick={() => logout()}
              className="logout"
            >
              <FaIcons.FaSignOutAlt className="menu-icon" />
              <span>Log out</span>
            </a>
            <div className="logo">
              <span>Powered By</span>
              <img className="llac-logo" src={llacLogo} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
